
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 55 55"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.5 45.498h44m-36.344 0v-5.866h-5.74v5.866m17.218.002V31.812h-5.739V45.5m17.217-.004v-21.51h-5.739v21.51m17.217.002V16.166h-5.738v29.332M6.286 25.945L40.722 2.48m-.962 7.82l.957-7.822-7.652-.978","fill":"none","stroke":"#269C45","stroke-width":"1.6","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    